import apiClient from './client';
import { Order, OrderStatus } from '../types/admin';

export const fetchOrders = async (status?: OrderStatus): Promise<Order[]> => {
  const { data } = await apiClient.get<Order[]>('/appmanage/orders', { params: status ? { status } : {} });
  return data;
};

export const acceptOrder = async (id: number, estimatedMinutes: number): Promise<void> => {
  await apiClient.patch(`/appmanage/orders/${id}/accept`, { estimatedMinutes });
};

export const rejectOrder = async (id: number): Promise<void> => {
  await apiClient.patch(`/appmanage/orders/${id}/reject`);
};

export const completeOrder = async (id: number): Promise<void> => {
  await apiClient.patch(`/appmanage/orders/${id}/complete`);
};

export const pickedUpOrder = async (id: number): Promise<void> => {
  await apiClient.patch(`/appmanage/orders/${id}/picked-up`);
};
